module.exports = "/_next/static/images/AIReadyData-c00a1bb8a167735a8ad5fb6297a34ebe.webp";